import * as React from "react";
import { GiftCardBalanceResponse } from "@app/interface/ProductGiftCard";
import { formatMoney } from "@shopify/theme-currency";
import config from "@app/config";

const GiftCardBalanceForm = () => {
  const [giftCardNumber, setGiftCardNumber] = React.useState("");
  const [giftCardPin, setGiftCardPin] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [balance, setBalance] = React.useState<null | number>(null);
  const [expiryDate, setExpiryDate] = React.useState<null | string>(null);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const response = await fetch(config.giftcard.endpoints.balance, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          operation: "BALANCE",
          voucher: giftCardNumber,
          pin: giftCardPin,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch balance");
      }

      const data: GiftCardBalanceResponse = await response.json();
      setBalance(data.balance.available_amount);
      setExpiryDate(data.balance.expiry_date);
    } catch (err) {
      setError("Failed to fetch balance. Please check your details and try again.");
    } finally {
      setLoading(false);
    }
  };

  const formattedExpiryDate = expiryDate ? new Date(expiryDate).toLocaleDateString() : "";

  const formDisabled = !giftCardNumber || !giftCardPin || loading;

  return (
    <>
      <h5 className="gift-card-balance-form__heading">Check your Gift Card balance</h5>
      <p className="gift-card-balance-form__message">
        Enter your gift card number to see your E-Gift card balance and expiry date.
      </p>

      <div className="gift-card-balance-form__content">
        <div className="gift-card-balance-form__inputs">
          <div className="form-group w-75">
            <label className="gift-card-balance-form__label" htmlFor="gift-card-number">
              Gift Card Number
            </label>
            <input
              type="text"
              id="gift-card-number"
              placeholder="Gift Card Number"
              value={giftCardNumber}
              onChange={(e) => setGiftCardNumber(e.target.value)}
            />
          </div>
          <div className="form-group w-25">
            <label className="gift-card-balance-form__label" htmlFor="gift-card-pin">
              Pin
            </label>
            <input
              type="text"
              id="gift-card-pin"
              placeholder="Pin"
              value={giftCardPin}
              onChange={(e) => setGiftCardPin(e.target.value)}
            />
          </div>
        </div>
        <button className="button button-black" type="button" onClick={handleSubmit} disabled={formDisabled}>
          {loading ? "Loading..." : "Check Your Balance"}
        </button>
        {error && <p className="gift-card-balance-form__error">{error}</p>}
      </div>

      {balance && (
        <div className="gift-card-balance-form__result">
          <p className="gift-card-balance-form__result--balance">
            Your Balance: {formatMoney(balance * 100).replace(".00", "")}
          </p>
          <p className="gift-card-balance-form__result--expiry">Expires: {formattedExpiryDate}</p>
        </div>
      )}
    </>
  );
};

export default GiftCardBalanceForm;
